export default __webpack_public_path__ + "static/media/img_windows-colorBkg.7adeed76.png";